export default {
  CREATE: "CREATE",
  MODIFY: "MODIFY",
  DETAIL: "DETAIL",
};
